import { render, staticRenderFns } from "./basic-layout.vue?vue&type=template&id=bfa4bbc4"
import script from "./basic-layout.vue?vue&type=script&lang=js"
export * from "./basic-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports